import { Database, MessageSquare, ShoppingCart } from "lucide-react";
import { useState } from "react";
import { Button } from "../../../../../components/ui/button";
import { OperationConfirmDialog } from "../../../../../components/ui/operation-confirm-dialog";

/**
 * Três botões, contra os quatro do entrego.
 *
 * O componente do entrego (checkout-action-buttons.tsx) liga o split
 * registro/envio pela presença de onEnviarOfertas e, sem ela, cai no modo
 * "WhatsApp" — tecnicamente reusável aqui. Não reusamos por um motivo concreto:
 * o texto de confirmação do modo "registro-ofertas" fala de "franquias fora do
 * piloto recebem envio ativo", que é verdade só no entrego. Uma cópia com três
 * botões diz a verdade para a iMile.
 */
interface ImileCheckoutActionButtonsProps {
  status: string;
  ops: string;
  date: string;
  onConfirmCheckout: () => void;
  onStartDoc: () => void;
  onSubmitRemessa: () => void;
  isConfirming: boolean;
  isStartingDoc: boolean;
  isSubmittingRemessa: boolean;
}

export function ImileCheckoutActionButtons({
  status,
  ops,
  date,
  onConfirmCheckout,
  onStartDoc,
  onSubmitRemessa,
  isConfirming,
  isStartingDoc,
  isSubmittingRemessa,
}: ImileCheckoutActionButtonsProps) {
  const [openWhatsapp, setOpenWhatsapp] = useState(false);
  const [openCompra, setOpenCompra] = useState(false);
  const [openInsertDb, setOpenInsertDb] = useState(false);

  // Ciclo: requested → confirmed → closed → payment_requested → committed.
  // As listas são de status BLOQUEADOS de propósito — o que não está nelas
  // habilita. "Inserir DB" é quem grava o committed, então precisa ficar ativo
  // nos dois estados do meio (closed e payment_requested); listar "closed" aqui
  // cobriria todo o ciclo anterior ao commit e travaria o fluxo.
  const isWhatsappDisabled = status === "closed" || status === "committed";
  const isDocDisabled = status === "requested" || status === "committed";
  const isInsertDbDisabled =
    status === "requested" || status === "confirmed" || status === "committed";

  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenWhatsapp(true)}
        disabled={isWhatsappDisabled || isConfirming}
      >
        <MessageSquare className="h-4 w-4 mr-2" />
        WhatsApp
      </Button>

      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenCompra(true)}
        disabled={isDocDisabled || isStartingDoc}
      >
        <ShoppingCart className="h-4 w-4 mr-2" />
        Compra
      </Button>

      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpenInsertDb(true)}
        disabled={isInsertDbDisabled || isSubmittingRemessa}
      >
        <Database className="h-4 w-4 mr-2" />
        Inserir DB
      </Button>

      <OperationConfirmDialog
        open={openWhatsapp}
        onOpenChange={setOpenWhatsapp}
        onConfirm={onConfirmCheckout}
        action="whatsapp"
        ops={ops}
        date={date}
        loading={isConfirming}
      />

      <OperationConfirmDialog
        open={openCompra}
        onOpenChange={setOpenCompra}
        onConfirm={onStartDoc}
        action="compra"
        ops={ops}
        date={date}
        loading={isStartingDoc}
      />

      <OperationConfirmDialog
        open={openInsertDb}
        onOpenChange={setOpenInsertDb}
        onConfirm={onSubmitRemessa}
        action="inserir-db"
        ops={ops}
        date={date}
        loading={isSubmittingRemessa}
      />
    </div>
  );
}
